import { library } from '~fontawesome-core/fontawesome-svg-core'

import {
  faWrench,
  faFaceFrown,
  faTriangleExclamation,
  faClock,
  faCircle,
  faPersonDigging,
  faArrowTurnLeft,
  faAngleRight,
  faAngleLeft,
  faCirclePlus,
  faUsers,
  faCalendarDays,
  faCheckCircle,
  faTimesCircle,
  faFileUser
} from '~fontawesome-core/pro-solid-svg-icons'
library.add(
  faWrench,
  faFaceFrown,
  faTriangleExclamation,
  faCirclePlus,
  faClock,
  faPersonDigging,
  faArrowTurnLeft,
  faCircle,
  faPersonDigging,
  faAngleRight,
  faAngleLeft,
  faUsers,
  faCalendarDays,
  faCheckCircle,
  faTimesCircle,
  faFileUser
)

export default library
